<template>
  <DateColumn :date="column.hires?.data[0]?.startDate" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateColumn from '@/components/GraphqlDataTable/columns/DateColumn.vue'

const EmploymentStartDateColumn = graphql(`
  fragment EmploymentStartDateColumn on Employment {
    hires {
      data {
        startDate
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentStartDateColumn> }>()
const column = computed(() => useFragment(EmploymentStartDateColumn, props.row))
</script>
